(function () {
  if (window.__customOrderCarouselInitialized) return;
  window.__customOrderCarouselInitialized = true;

  const initCustomOrderCarousel = (root = document) => {
    const sections = root.querySelectorAll('.section-custom-order-carousel');

    sections.forEach((section) => {
      const slider = section.querySelector('.custom-order-carousel__slider');

      if (!slider || slider.swiper) {
        return;
      }

      const btnPrev = section.querySelector('.custom-order-carousel__slider-nav .swiper-button-prev');
      const btnNext = section.querySelector('.custom-order-carousel__slider-nav .swiper-button-next');
      const cardCount = Number(slider.dataset.cardCount || 0);

      if (cardCount < 1) {
        return;
      }

      new Swiper(slider, {
        speed: 900,
        spaceBetween: 12,
        slidesPerView: 1.14,
        slidesPerGroup: 1,
        watchOverflow: true,
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
        breakpoints: {
          576: {
            slidesPerView: Math.min(cardCount, 1.34),
          },
          990: {
            slidesPerView: Math.min(cardCount, 1.7),
          },
          1360: {
            slidesPerView: Math.min(cardCount, 2.18),
          },
        },
      });
    });
  };

  initCustomOrderCarousel();

  document.addEventListener('shopify:section:load', function (event) {
    initCustomOrderCarousel(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const slider = event.target.querySelector('.custom-order-carousel__slider');

    if (slider && slider.swiper) {
      slider.swiper.destroy(true, true);
    }
  });
})();
